import _tmpl from "./iconInteractive.html";
import { LightningElement, registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import { c as classNames } from "ax/chunk_index";
let Size = /*#__PURE__*/function (Size) {
  Size["Default"] = "default";
  Size["Large"] = "large";
  Size["Small"] = "small";
  Size["XSmall"] = "xsmall";
  return Size;
}({});
let Theme = /*#__PURE__*/function (Theme) {
  Theme["Default"] = "default";
  Theme["Blue"] = "blue";
  Theme["Red"] = "red";
  Theme["Pink"] = "pink";
  Theme["Indigo"] = "indigo";
  Theme["Teal"] = "teal";
  Theme["Purple"] = "purple";
  Theme["Green"] = "green";
  Theme["HotOrange"] = "hot-orange";
  Theme["Violet"] = "violet";
  Theme["Yellow"] = "yellow";
  return Theme;
}({});
let TransparentBackground = /*#__PURE__*/function (TransparentBackground) {
  TransparentBackground["Transparent"] = "true";
  TransparentBackground["Default"] = "false";
  return TransparentBackground;
}({});
class IconInteractive extends LightningElement {
  constructor(...args) {
    super(...args);
    this.theme = Theme.Default;
    this.size = Size.Default;
    this.ariaLabel = null;
    this.ariaLive = null;
    this.type = null;
    this.form = null;
    this.disabled = false;
    this.href = null;
    this.icon = void 0;
    this.iconDescription = void 0;
    this.transparentBackground = TransparentBackground.Default;
  }
  focus() {
    this.template.querySelector("ax-button")?.focus();
  }
  get classes() {
    return classNames("element", {
      [`variant-tertiary`]: true,
      [`theme-${this.theme}`]: this.theme !== "default" && Object.values(Theme).includes(this.theme),
      [`size-${this.size}`]: this.size !== "default" && Object.values(Size).includes(this.size),
      [`transparent-background`]: this.transparentBackground === "true"
    });
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(IconInteractive, {
  publicProps: {
    theme: {
      config: 0
    },
    size: {
      config: 0
    },
    ariaLabel: {
      config: 0
    },
    ariaLive: {
      config: 0
    },
    type: {
      config: 0
    },
    form: {
      config: 0
    },
    disabled: {
      config: 0
    },
    href: {
      config: 0
    },
    icon: {
      config: 0
    },
    iconDescription: {
      config: 0
    },
    transparentBackground: {
      config: 0
    }
  },
  publicMethods: ["focus"]
});
const __lwc_component_class_internal = _registerComponent(IconInteractive, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;